import { Link } from "react-router-dom";
import { useT } from "../hooks/useT";
import { useState, useEffect, useRef } from "react";

export default function Footer() {
  const t = useT();
  const watermarkRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      if (!watermarkRef.current) return;
      const rect = watermarkRef.current.getBoundingClientRect();
      const viewH = window.innerHeight;
      if (rect.top < viewH && rect.bottom > 0) {
        const progress = (viewH - rect.top) / (viewH + rect.height);
        setOffset((progress - 0.5) * -40);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer data-testid="footer" className="relative py-20 md:py-28 bg-[var(--bg-default)] border-t overflow-hidden" style={{ borderColor: 'var(--rule)' }}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        {/* Info + Legal links */}
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <p className="font-sans text-[12px] text-[var(--text-tertiary)]">{t.footer.address}</p>
              <span className="text-[var(--text-tertiary)]" style={{ fontSize: '4px' }}>&#9679;</span>
              <p className="font-sans text-[12px] text-[var(--text-tertiary)]">{t.footer.est}</p>
            </div>
            <p className="font-sans text-[13px] text-[var(--text-tertiary)] max-w-[400px] leading-relaxed">{t.footer.descriptor}</p>
          </div>

          <div className="flex flex-col gap-2 md:items-end">
            <Link to="/terms" data-testid="footer-terms-link" className="font-sans text-[11px] uppercase tracking-[0.12em] text-[var(--text-tertiary)] transition-colors duration-150 hover:text-[var(--text-secondary)]">
              {t.footer.terms}
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="font-sans text-[11px] uppercase tracking-[0.12em] text-[var(--text-tertiary)] transition-colors duration-150 hover:text-[var(--text-secondary)]">
              {t.footer.privacy}
            </Link>
            <Link to="/risk" data-testid="footer-risk-link" className="font-sans text-[11px] uppercase tracking-[0.12em] text-[var(--text-tertiary)] transition-colors duration-150 hover:text-[var(--text-secondary)]">
              {t.footer.risk}
            </Link>
          </div>
        </div>

        <div className="h-px bg-[var(--rule)] mb-6" />

        <div className="flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-sans text-[11px] text-[var(--text-tertiary)]">
            &copy; {new Date().getFullYear()} Leon Galt Investments Inc.
          </p>
          <p className="font-sans text-[11px] text-[var(--text-tertiary)]">{t.footer.portal}</p>
        </div>
      </div>

      {/* Massive watermark with parallax drift */}
      <div ref={watermarkRef} className="mt-16 md:mt-24 select-none pointer-events-none overflow-hidden">
        <p
          className="font-serif uppercase text-center whitespace-nowrap"
          style={{
            fontSize: 'clamp(60px, 13vw, 200px)',
            letterSpacing: '0.12em',
            color: '#1e1e1e',
            fontWeight: 300,
            lineHeight: 0.8,
            transform: `translateY(${offset}px)`,
            transition: 'transform 0.15s linear',
          }}
        >
          LEON GALT
        </p>
      </div>
    </footer>
  );
}
